module.exports = __webpack_public_path__ + "static/media/custom_falloffs.8f40dc2b.webm";